import { SxProps, Theme } from '@mui/material';

export const OrderHistoryDetailsProductNameSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	color: '#2C2C2C',
	fontWeight: 600,
	mb: '5px',
};

export const OrderHistoryDetailsProductTextDetailsSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#929292',
	mb: { xs: '0px', md: '5px' },
};

export const OrderHistoryDetailsProductTextDetails2SX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#929292',
	marginRight: '8px',
};

export const OrderHistoryDetailsProductTextValueSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 600,
};

export const OrderHistoryDetailsProductTextDiscountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 600,
	color: '#BF0000',
};
